// The CEO Office guide (40_CeoOffice.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Three screens',
  tabsB: 'Tickets are the items being tracked, Leads is the new-account pipeline, Daily is the four morning blocks. The number on a tab is how many are behind it.',
  desksT: 'Desks',
  desksB: 'Pick a desk to see only its queue; All adds them up. The queue holds items nobody has taken yet.',
  newT: 'New ticket',
  newB: 'Raise a ticket by hand when the request did not arrive by mail. Mail forwarded to the CEO Office address becomes a ticket by itself.',
  cardsT: 'Counters',
  cardsB: 'Open, overdue, untouched, waiting on CEO, no entity, closed this week. Click a card to list only those tickets; click it again to clear.',
  filtersT: 'Search and export',
  filtersB: 'Search reads the title and the sender. Reset clears every filter, and Export Excel saves what the table shows.',
  tableT: 'The tickets',
  tableB: 'One row per ticket. Use the funnel on a column header to filter and click the header to sort; click a ticket to open its details, notes and mail history.',
};
const ko = {
  tabsT: '세 개의 화면',
  tabsB: '티켓은 추적 중인 건, Leads는 신규 거래처 파이프라인, Daily는 매일 아침의 네 블록입니다. 탭의 숫자는 해당 건수입니다.',
  desksT: '데스크',
  desksB: '데스크를 선택하면 해당 큐만 보이고, 전체는 모두 합친 것입니다. 큐에는 아직 담당자가 없는 건이 있습니다.',
  newT: '새 티켓',
  newB: '메일이 아닌 다른 경로로 요청이 왔을 때 직접 티켓을 만듭니다. CEO Office 주소로 전달된 메일은 자동으로 티켓이 됩니다.',
  cardsT: '카운터',
  cardsB: '진행 중, 기한 초과, 미처리, CEO 대기, 법인 미지정, 이번 주 종료입니다. 카드를 클릭하면 해당 티켓만 보이고, 다시 클릭하면 해제됩니다.',
  filtersT: '검색과 내보내기',
  filtersB: '검색은 제목과 발신자를 함께 찾습니다. 초기화는 모든 필터를 지우고, Excel 내보내기는 표에 보이는 내용을 저장합니다.',
  tableT: '티켓 목록',
  tableB: '티켓당 한 행입니다. 열 머리글의 깔때기로 필터링하고 머리글을 클릭해 정렬하며, 티켓을 클릭하면 상세, 메모, 메일 이력이 열립니다.',
};
const vi = {
  tabsT: 'Ba màn hình',
  tabsB: 'Tickets là các việc đang theo dõi, Leads là pipeline khách hàng mới, Daily là bốn khối xem mỗi sáng. Số trên mỗi tab là số mục bên trong.',
  desksT: 'Desk',
  desksB: 'Chọn một desk để chỉ xem hàng chờ của desk đó; All là tổng của tất cả. Hàng chờ chứa các việc chưa có người nhận.',
  newT: 'Ticket mới',
  newB: 'Tự tạo ticket khi yêu cầu không đến qua mail. Mail chuyển tiếp tới địa chỉ CEO Office sẽ tự thành ticket.',
  cardsT: 'Bộ đếm',
  cardsB: 'Đang xử lý, quá hạn, chưa ai đụng tới, chờ CEO, chưa có pháp nhân, đã đóng trong tuần. Bấm một thẻ để chỉ liệt kê các ticket đó; bấm lại để bỏ lọc.',
  filtersT: 'Tìm kiếm và xuất file',
  filtersB: 'Ô tìm kiếm đọc cả tiêu đề lẫn người gửi. Reset xóa mọi bộ lọc, còn Export Excel lưu đúng những gì bảng đang hiển thị.',
  tableT: 'Danh sách ticket',
  tableB: 'Mỗi dòng là một ticket. Dùng biểu tượng phễu ở tiêu đề cột để lọc, bấm tiêu đề để sắp xếp; bấm vào ticket để mở chi tiết, ghi chú và lịch sử mail.',
};
const zh = {
  tabsT: '三个页面',
  tabsB: 'Tickets 是正在跟踪的事项,Leads 是新客户开发 pipeline,Daily 是每天早上的四个板块。标签上的数字是其中的数量。',
  desksT: 'Desk',
  desksB: '选择一个 desk 即可只看它的队列;All 是全部相加。队列里是还没有人接手的事项。',
  newT: '新建 ticket',
  newB: '请求不是通过邮件到达时,可以手动创建 ticket。转发到 CEO Office 地址的邮件会自动成为 ticket。',
  cardsT: '计数卡',
  cardsB: '进行中、已逾期、未处理、等待 CEO、未指定主体、本周已关闭。点击卡片只列出对应的 ticket,再点一次取消。',
  filtersT: '搜索与导出',
  filtersB: '搜索会同时查找标题和发件人。重置会清除所有筛选,导出 Excel 会保存表格当前显示的内容。',
  tableT: 'Ticket 列表',
  tableB: '每个 ticket 一行。用列标题上的漏斗筛选,点击标题排序;点击 ticket 可打开详情、备注和邮件记录。',
};
const dictionary = { ns: 'tourCeo', en, ko, vi, zh };
export default dictionary;
